import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { useLang } from '../lib/i18n/LanguageContext';
import { dictionary } from '../lib/i18n/dictionary';
export function FAQPage() {
  const {
    lang
  } = useLang();
  const t = dictionary.faq;
  const items = t.items[lang];
  const [open, setOpen] = useState<number | null>(0);
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-753">
      <div className="max-w-3xl mx-auto px-5 md:px-8" data-id="element-754">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-755" />

        <ul className="mt-12 space-y-3" data-id="element-756">
          {items.map((it, i) => {
          const isOpen = open === i;
          return <li key={it.q} data-id="element-757">
                <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.04
            }} className={`border rounded-md transition-colors ${isOpen ? 'border-gold/40 bg-gold/[0.03]' : 'border-slate-200 bg-white'}`} data-id="element-758">
                  <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left" aria-expanded={isOpen} data-id="element-759">
                    <span className="font-serif text-[17px] text-navy-deep leading-snug" data-id="element-760">
                      {it.q}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-slate-400 shrink-0 transition-transform ${isOpen ? 'rotate-180 text-gold-deep' : ''}`} data-id="element-761" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-762">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-763">
                        <p className="px-6 pb-6 text-slate-600 leading-relaxed text-[15px]" data-id="element-764">
                          {it.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>
              </li>;
        })}
        </ul>
      </div>
    </main>;
}